import React from 'react';
import { Tooltip } from '@odo/shared-ui';
import type { ConversationStatus } from '../../services/conversations';
import { FLUID_LABEL_CLASS, FLUID_PILL_TIGHT_CLASS } from '../shared/fluidPill';

// Solid pills matching TeamSelector's trigger: same shape, white text on a
// saturated fill. Teal/amber echo the unread row tint for each thread.
export const CONVERSATION_STATUS_COLORS: Record<ConversationStatus, string> = {
    internal: '#007E87',
    external: '#B45309'
};

export const CONVERSATION_STATUS_LABELS: Record<ConversationStatus, string> = {
    internal: 'Internal',
    external: 'External'
};

export const CONVERSATION_STATUS_OPTIONS: { value: ConversationStatus; label: string }[] = (
    Object.keys(CONVERSATION_STATUS_LABELS) as ConversationStatus[]
).map((value) => ({ value, label: CONVERSATION_STATUS_LABELS[value] }));

interface ConversationStatusBadgeProps {
    status: ConversationStatus;
}

// Fluid: sits in a FLUID_CELL_CLASS column and shrinks down to its colour swatch.
const ConversationStatusBadge: React.FC<ConversationStatusBadgeProps> = ({ status }) => (
    <Tooltip content={CONVERSATION_STATUS_LABELS[status]}>
        <span
            className={`inline-flex items-center justify-center gap-1.5 min-w-[min(90px,100%)] max-w-full h-7 text-xs font-semibold px-3.5 py-1.5 rounded-md ${FLUID_PILL_TIGHT_CLASS}`}
            style={{ backgroundColor: CONVERSATION_STATUS_COLORS[status], color: '#fff' }}
        >
            <span className="w-1.5 h-1.5 rounded-full bg-white/40 flex-shrink-0" />
            <span className={FLUID_LABEL_CLASS}>{CONVERSATION_STATUS_LABELS[status]}</span>
        </span>
    </Tooltip>
);

export default ConversationStatusBadge;
